import { render, staticRenderFns } from "./OrderModeSwitcher.vue?vue&type=template&id=0722e07f&scoped=true"
import script from "./OrderModeSwitcher.vue?vue&type=script&lang=js"
export * from "./OrderModeSwitcher.vue?vue&type=script&lang=js"
import style0 from "./OrderModeSwitcher.vue?vue&type=style&index=0&id=0722e07f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0722e07f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0722e07f')) {
      api.createRecord('0722e07f', component.options)
    } else {
      api.reload('0722e07f', component.options)
    }
    module.hot.accept("./OrderModeSwitcher.vue?vue&type=template&id=0722e07f&scoped=true", function () {
      api.rerender('0722e07f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/orderModeSwitch/OrderModeSwitcher.vue"
export default component.exports